import { DEVICE_PLATFORM } from '../constants';

const isDevelopment = process.env.NODE_ENV === 'development';

const SEVERITY_LOG_COLOR_MAP = {
  error: 'red',
  info: 'blue',
};

export const reportRoutingError = (details) => {
  const userAgent =
    typeof window !== 'undefined' ? navigator.userAgent : 'Unknown';

  const payload = {
    ...details,
    userAgent: `\`${userAgent}\``,
    timestamp: new Date().toISOString(),
  };

  if (isDevelopment) {
    sendLogToConsole('🚨 Deep Link Routing Failure Detected', 'error', payload);
  } else {
    sendLogToSlack('🚨 *Deep Link Routing Failure Detected*', payload);
  }
};

export const trackInAppNavigation = (details) => {
  const userAgent =
    typeof window !== 'undefined' ? navigator.userAgent : 'Unknown';

  const platformText =
    details.platform === DEVICE_PLATFORM.IOS
      ? 'iOS Instagram Webview'
      : details.platform === DEVICE_PLATFORM.ANDROID
        ? 'Android Instagram Webview'
        : details.platform;

  const payload = {
    ...details,
    event: 'In-App Navigation',
    platform: platformText,
    userAgent: `\`${userAgent}\``,
    timestamp: new Date().toISOString(),
  };

  if (isDevelopment) {
    sendLogToConsole('📊 In-App Navigation Tracked', 'info', payload);
  } else {
    sendLogToSlack('📊 *In-App Navigation Tracked*', payload);
  }
};

const sendLogToConsole = (messageText, severity = 'info', payloadData) => {
  console.group(
    `%c${messageText}`,
    `color: white; background: ${SEVERITY_LOG_COLOR_MAP[severity]}; font-size: 14px; padding: 4px;`
  );
  console.table(payloadData);
  console.groupEnd();
};

const sendLogToSlack = (messageText, payloadData) => {
  if (isDevelopment) {
    return;
  }

  try {
    fetch('/api/slack', {
      method: 'POST',
      body: JSON.stringify({ messageText, payloadData }),
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    });
  } catch (error) {
    console.error('Failed to trigger internal Slack API route', error);
  }
};
